module.exports = __webpack_public_path__ + "static/competicao-6-3d6c6071411085d4147f52e1c1e6209e.jpeg";